import { basicEnum } from "./base";

export const DisbursementTypeEnum = basicEnum([
    {
        label: "Associate",
        value: "A",
    },
    {
        label: "Marketing",
        value: "M",
    },
    {
        label: "System",
        value: "S",
    },
]);

export namespace DisbursementTypeEnum {
    export type Labels = (typeof DisbursementTypeEnum)["labels"][number];
    export type Values = (typeof DisbursementTypeEnum)["values"][number];
}
